import { LOCALISE_LANGUAGE_FIELD_NAME } from '@pkg/config/sanity/constants';
import { WWW_AUDIENCE_FILTER } from '@pkg/config/sanity/audience';
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

const type = `_type == "${DOCUMENT.BRAND_PROFILE}"`;
const locale = `${LOCALISE_LANGUAGE_FIELD_NAME} == $locale`;
const slug = 'slug.current == $slug';
const audience = WWW_AUDIENCE_FILTER;

/** Portable blocks projected from the first {@link DOCUMENT.FRAGMENT_BRAND_PROFILE_DEFAULTS} for the locale. */
const brandProfileDefaultsPortable = `{
  "brandDefaultDescription": brandDefaultDescription[] {
    ${portableTextWithReferences}
  },
  "cityDefaultDescription": cityDefaultDescription[] {
    ${portableTextWithReferences}
  },
  savedCo2Label,
  mealsSavedLabel,
  citiesListTitle,
  noCitiesAvailableText,
  surpriseBagsListTitle,
  emptyStateText,
  "defaultSeoSocial": seoSocial {
    metaTitle,
    metaDescription,
    socialImage
  }
}`;

/** `brandProfile` by locale + URL slug (last path segment). */
export const brandProfileDocumentBySlug = groq`*[${type} && ${locale} && ${slug} && ${audience}][0] {
  _type,
  name,
  pageTitle,
  chainId,
  showRatings,
  showSavedCo2,
  showMealsSaved,
  description[] {
    ${portableTextWithReferences}
  },
  "brandProfileDefaultTexts": *[_type == "${DOCUMENT.FRAGMENT_BRAND_PROFILE_DEFAULTS}" && ${LOCALISE_LANGUAGE_FIELD_NAME} == $locale][0]${brandProfileDefaultsPortable},
  seoSocial {
    metaTitle,
    metaDescription,
    socialImage
  },
  "profileSlug": slug.current,
  ${LOCALISE_LANGUAGE_FIELD_NAME},
  heroImage {
    alt,
    "url": asset->url
  },
  logo {
    alt,
    "url": asset->url
  }
}`;

/** Published brand profile for locale + Sprout chain ID (surprise bag → partner link). */
export const brandProfileByChainId = groq`*[${type} && ${locale} && chainId == $chainId && ${audience}][0] {
  name,
  "profileSlug": slug.current,
  "language": ${LOCALISE_LANGUAGE_FIELD_NAME},
}`;
